<div class="playlists-container">

  <div class="content">

    <div class="playlists pt-32">
      <div class="playlist-tiles">
        @for(item of playlistsStore.list(); track item.id) {

          <div class="playlist-card" (click)="selectPlaylist(item.id, item.name)">

            <img [ngSrc]="item.image || 'assets/images/note-2.jpeg'" height="200" width="200" priority alt="Album cover">

            <!--          <div class="playlist-data">-->
            <!--            <div class="playlist-name">-->
            <!--              {{item.name}}-->
            <!--            </div>-->

            <!--          </div>-->

          </div>
        }

      </div>
      <mat-paginator [length]="playlistsStore.total()" [pageSizeOptions]="[10, 15, 30]" pageSize="15" aria-label="Select page" style="background: none" (page)="changePlaylistsPage($event)"></mat-paginator>
    </div>


<!--    <div #tracksList>-->
<!--      @if(playlistTracks.length > 0) {-->
<!--        <app-tracks-list-->
<!--          [dataSource]="playlistsStore.tracks()"-->
<!--          [tracksTotal]="playlistsStore.tracksTotal()"-->
<!--          [isLoading]="playlistsStore.isTracksLoading()"-->
<!--          (sortChanged)="sortChange($event)"-->
<!--          (pageChanged)="changePage($event)"-->
<!--          (downloadClicked)="download($event)"-->
<!--        ></app-tracks-list>-->
<!--      }-->
<!--    </div>-->
  </div>

  <div class="sidebar">
    <h4 class="pb-24">Top 20</h4>

    <app-top-tracks></app-top-tracks>
  </div>
</div>
